import React from 'react';

interface LineGridProps {
  gridSize?: number;
  width?: number;
  height?: number;
  lineColor?: string;
  majorLineColor?: string;
  lineWidth?: number;
  opacity?: number;
  offsetX?: number;
  offsetY?: number;
  scale?: number;
}

export const LineGrid = React.forwardRef<HTMLDivElement, LineGridProps>(({
  gridSize = 10,
  lineColor = 'rgba(255,255,255,0.05)',
  majorLineColor = 'rgba(255,255,255,0.12)',
  lineWidth = 0.3,
  opacity = 1,
  offsetX = 0,
  offsetY = 0,
  scale = 1
}, ref) => {
  const safeScale = scale > 0 ? scale : 1;
  const safeGridSize = gridSize > 0 ? gridSize : 10;
  const renderedMinorGridSize = Math.max(4, safeGridSize * safeScale);
  // Major grid is always 10× minor (10px → 100px at scale=1)
  const renderedMajorGridSize = renderedMinorGridSize * 10;

  return (
    <div
      ref={ref}
      className="absolute inset-0 pointer-events-none"
      style={{
        zIndex: 0,
        backgroundImage: `
          linear-gradient(${lineColor} 1px, transparent 1px),
          linear-gradient(90deg, ${lineColor} 1px, transparent 1px),
          linear-gradient(${majorLineColor} 1px, transparent 1px),
          linear-gradient(90deg, ${majorLineColor} 1px, transparent 1px)
        `,
        backgroundSize: `
          ${renderedMinorGridSize}px ${renderedMinorGridSize}px,
          ${renderedMinorGridSize}px ${renderedMinorGridSize}px,
          ${renderedMajorGridSize}px ${renderedMajorGridSize}px,
          ${renderedMajorGridSize}px ${renderedMajorGridSize}px
        `,
        backgroundPosition: `
          ${offsetX}px ${offsetY}px,
          ${offsetX}px ${offsetY}px,
          ${offsetX}px ${offsetY}px,
          ${offsetX}px ${offsetY}px
        `,
        opacity
      }}
    />
  );
});

LineGrid.displayName = 'LineGrid';

export default LineGrid;
